// @ts-nocheck
// ========================================
// ブレークポイント定義
// ========================================

/**
 * ブレークポイント値（px）
 */
export const BREAKPOINTS = {
  smallMobile: 480,  // 小型スマホ縦
  mobile: 768,       // スマホ横 / タブレット縦
  tablet: 1024,      // タブレット横
  desktop: 1280,     // デスクトップ
};

/**
 * メディアクエリ文字列
 */
export const MEDIA_QUERIES = {
  smallMobile: `(max-width: ${BREAKPOINTS.smallMobile}px)`,
  mobile: `(max-width: ${BREAKPOINTS.mobile}px)`,
  tablet: `(max-width: ${BREAKPOINTS.tablet}px)`,
  desktop: `(min-width: ${BREAKPOINTS.mobile + 1}px)`,
};

/**
 * カードサイズ計算
 * 5スロット + gap 4px × 4 + 左右padding 8px × 2 = 32px
 */
export const CARD_SIZE = {
  // デスクトップ
  desktop: {
    slotWidth: 100,
    slotHeight: 130,
    handWidth: 100,
    handHeight: 130,
    fontSize: 10,
  },
  // モバイル（可変）
  mobile: {
    // calc((100vw - 32px) / 5 - 4px)
    slotWidth: 'clamp(55px, calc((100vw - 32px) / 5 - 4px), 100px)',
    slotHeight: 'clamp(72px, calc((100vw - 32px) / 5 * 1.3 - 4px), 130px)',
    // 手札は少し小さめ
    handWidth: 'clamp(55px, 16vw, 90px)',
    handHeight: 'clamp(72px, 20.8vw, 117px)',
    fontSize: 'clamp(6px, 1.8vw, 10px)',
  },
};

/**
 * レイアウト設定
 */
export const LAYOUT = {
  desktop: {
    sidePanelWidth: 280,
    headerPadding: '12px 24px',
    gap: 12,
    padding: 12,
  },
  mobile: {
    sidePanelWidth: 0, // モバイルでは非表示
    headerPadding: '8px 12px',
    gap: 4,
    padding: 8,
  },
};

export default {
  BREAKPOINTS,
  MEDIA_QUERIES,
  CARD_SIZE,
  LAYOUT,
};
